import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { FetchDataTypes } from "../../api/api";
import { Pie, Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Legend, Tooltip } from "chart.js";
Chart.register(ArcElement, Legend, Tooltip);

interface SAProps {
  title: string;
}

interface Fund {
  fund: string;
  fundName: string;
  fundType: string;
  fundBalance: number;
  portfolioBalance: number;
  fundPercentage: number;
}

interface Props {
  funds: Fund[];
}

function SectorAllocation({ title }: any) {
  const [sectorAllocation, setSectorAllocation] = useState<any>(null);
  const selectedClient: any = Cookies.get("client");
  useEffect(() => {
    FetchDataTypes(
      "FundBalances",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    )
      .then((response) => response.json())
      .then((response) => {
        setSectorAllocation(response);
      });
  }, []);

  const total = sectorAllocation?.reduce(
    (sum: any, item: any) => sum + item.fundBalance,
    0
  );

  const groupedData = sectorAllocation?.reduce((acc: any, item: any) => {
    const key = item.fundType;
    const existing = acc[key] ?? { total: 0, percentage: 0, data: [] };
    existing.total += item.fundBalance;
    existing.percentage = `${((existing.total / total) * 100).toFixed(0)}`;
    existing.data.push(item);
    acc[key] = existing;
    return acc;
  }, {} as Record<string, { total: number; percentage: number; data: typeof sectorAllocation }>);

  const chartData = {
    labels: groupedData && Object.keys(groupedData),
    datasets: [
      {
        label: "%",
        data:
          groupedData &&
          Object.values(groupedData).map((item: any) => `${item?.percentage}`),
        backgroundColor: [
          "#3a7ddd",
          "#7cb5ec",
          "#87cefa",
          "#b0e0e6",
          "#ee82ef",
          "#3a7ddd",
          "#7cb5ec",
          "#87cefa",
          "#b0e0e6",
          "#ee82ef",
        ],
      },
    ],
  };
  

  return (
    <div className="card w-100">
      <div className="card-header">
        <h5 className="card-title">{title ? title : "Fund Sources"}</h5>
      </div>
      <div className="card-body">
        <div className="chart chart-xs">
          <div className="chartjs-size-monitor">
            <div className="chartjs-size-monitor-shrink">
              <div className="">
                <Doughnut
                  data={chartData}
                  options={{
                    elements: {
                      point: {
                        radius: 1,
                      },
                    },

                    plugins: {
                      legend: {
                        position: "bottom",
                        labels: {
                          usePointStyle: true, //for style circle
                        },
                      },
                      tooltip: {
                        callbacks: {
                          label: (context) => {
                            const label = context.label || '';
                            const value = context.parsed;
                            return `${label} ${value}%`;
                          }
                        }
                      }
                     
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { SectorAllocation };
